var _rect, _path, _line, _rect2, _path2, _line2, _rect3, _path3, _line3, _rect4, _path4, _line4, _rect5, _rect6, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepper4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 752,
    height: 33,
    viewBox: "0 0 752 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#096F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 13.1667L14.4717 20.0286C14.2114 20.289 13.7893 20.289 13.5289 20.0286L10.667 17.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 15.5,
    x2: 175,
    y2: 15.5,
    stroke: "#096F00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0.1 8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#096F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.334 13.1667L194.472 20.0286C194.211 20.289 193.789 20.289 193.529 20.0286L190.667 17.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 217,
    y1: 15.5,
    x2: 355,
    y2: 15.5,
    stroke: "#096F00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0.1 8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#096F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M381.334 13.1667L374.472 20.0286C374.211 20.289 373.789 20.289 373.529 20.0286L370.667 17.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 397,
    y1: 15.5,
    x2: 535,
    y2: 15.5,
    stroke: "#096F00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0.1 8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#096F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M561.334 13.1667L554.472 20.0286C554.211 20.289 553.789 20.289 553.529 20.0286L550.667 17.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 577,
    y1: 15.5,
    x2: 715,
    y2: 15.5,
    stroke: "#096F00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0.1 8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 720.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 720.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#096F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M735.593 22.66C734.814 22.66 734.121 22.5267 733.513 22.26C732.905 21.9827 732.393 21.5827 731.977 21.06L733.225 19.812C733.449 20.1533 733.763 20.4253 734.169 20.628C734.585 20.8307 735.049 20.932 735.561 20.932C736.03 20.932 736.441 20.8467 736.793 20.676C737.145 20.5053 737.422 20.26 737.625 19.94C737.827 19.62 737.929 19.2413 737.929 18.804C737.929 18.3453 737.827 17.9667 737.625 17.668C737.433 17.3587 737.171 17.1293 736.841 16.98C736.521 16.82 736.174 16.74 735.801 16.74C735.374 16.74 734.99 16.788 734.649 16.884C734.318 16.98 733.993 17.1507 733.673 17.396L733.721 16.244C733.891 16.02 734.089 15.8387 734.313 15.7C734.537 15.5507 734.798 15.4387 735.097 15.364C735.395 15.2893 735.747 15.252 736.153 15.252C736.942 15.252 737.603 15.4173 738.137 15.748C738.681 16.0787 739.091 16.5213 739.369 17.076C739.646 17.62 739.785 18.228 739.785 18.9C739.785 19.6253 739.603 20.2707 739.241 20.836C738.889 21.4013 738.398 21.8493 737.769 22.18C737.139 22.5 736.414 22.66 735.593 22.66ZM733.673 17.396L732.665 16.388L733.161 11.3L734.841 11.3L734.265 16.596L733.673 17.396ZM733.481 12.948L733.161 11.3L739.161 11.3V12.948L733.481 12.948Z",
    fill: "#096F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper4);
export default __webpack_public_path__ + "static/media/Stepper4.8ed8d591eda1f4e8d6a8030b478b5c1e.svg";
export { ForwardRef as ReactComponent };